import { ApiError } from '@bombom/shared/apis';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { challengesQueries } from '@/apis/challenges/challenges.query';
import type { UpdateChallengeDailyGuideRequest } from '@/apis/challenges/challenges.api';

type UseUpdateChallengeDailyGuideMutationParams = {
  challengeId: number;
  dayIndex: number;
  onSuccess?: () => void;
};

export const useUpdateChallengeDailyGuideMutation = ({
  challengeId,
  dayIndex,
  onSuccess,
}: UseUpdateChallengeDailyGuideMutationParams) => {
  const queryClient = useQueryClient();

  return useMutation({
    ...challengesQueries.mutation.updateDailyGuide(),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: challengesQueries.schedule(challengeId).queryKey,
        }),
        queryClient.invalidateQueries({
          queryKey: challengesQueries.dailyGuide(challengeId, dayIndex)
            .queryKey,
        }),
      ]);
      alert('데일리 가이드가 수정되었습니다.');
      onSuccess?.();
    },
    onError: (error) => {
      if (error instanceof ApiError) {
        alert(error.message);
        return;
      }

      alert('데일리 가이드 수정에 실패했습니다.');
    },
  });
};

export type UpdateChallengeDailyGuideMutationParams = {
  challengeId: number;
  guideId: number;
  image?: File;
  request: UpdateChallengeDailyGuideRequest;
};
